import { Fragment } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import useStyles from "./styles";

export const FailedTableInfo = ({ rows }) => {
  const classes = useStyles();

  const persons = rows ?? [];

  return (
    <Fragment>
      <Typography color="primary" variant="h6">
        Errores en el archivo
      </Typography>

      <div className={classes.tableWrapper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>Nombre</TableCell>
              <TableCell className={classes.headerCell} align="center">
                Error
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {persons.map((row, index) => (
              <TableRow key={index}>
                <TableCell className={classes.cell}>{row.nombre}</TableCell>
                <TableCell className={classes.errorCell} align="center">
                  {row.error}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Fragment>
  );
};
